/**
 * Created by Administrador on 17/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('items', {
                parent: 'app',
                url: '/items?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/item/items.html',
                        controller: 'itemCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('items')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['item','subClassification', 'classification']);
                            }],
                            items: ['itemService', '$stateParams', function (itemService, $stateParams) {
                             return itemService.getItems($stateParams.page, $stateParams.size);
                             }],
                            fareItems: ['fareItemService', function (fareItemService) {
                                return fareItemService.getFareItemList();
                            }]
                        }
                    }
                }
            })
            .state('itemNew', {
                parent: 'app',
                url: '/item/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/item/newItem.html',
                        controller: 'newEditItemCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('items')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['item']);
                            }],
                            action: [function() {
                                return "new";
                            }],
                            item: [function() {
                                return null;
                            }],
                            classifications: ['classificationService', function (classificationService) {
                                return classificationService.getClassificationList();
                            }],
                            fareItems: [function() {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('itemEdit', {
                parent: 'app',
                url: '/item/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/item/editItem.html',
                        controller: 'newEditItemCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('items')
                            }],
                            item: ['itemService', '$stateParams', function (itemService, $stateParams) {
                             return itemService.getItem($stateParams.id,true)
                             }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['item']);
                            }],
                            action: [function() {
                                return "edit";
                            }],
                            classifications: ['classificationService', function (classificationService) {
                                return classificationService.getClassificationList();
                            }],
                            fareItems: ['fareItemService','$stateParams', function (fareItemService,$stateParams) {
                                return fareItemService.getFareItemByItemId($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('itemDelete', {
                parent: 'items',
                url: '/item/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/adminClassification/item/deleteItem.html',
                        controller: 'deleteItemCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            item: ['itemService', function (itemService) {
                                return itemService.getItem($stateParams.id,false)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['item']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('items', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
